module.exports = __webpack_public_path__ + "img/dianyuanchazuo.prt.ab174a5b.jpg";